import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
} from "react-icons/ai";
import {
  SiHackthebox,
  SiTryhackme,
} from "react-icons/si";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Created by Soumyajit Behera, Edited by Aaron</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} Soumyajit Behera and Aaron</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/cyberweet"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/w33t/"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://app.hackthebox.com/profile/353518"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <SiHackthebox />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://tryhackme.com/p/weet"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <SiTryhackme />
              </a>
            </li>
          </ul>
          <script defer data-domain="w33t.io" src="https://plausible.io/js/plausible.js"></script></Col>
      </Row>
    </Container>
  );
}

export default Footer;
